// Donut chart — composição (canais de tráfego, distribuição PJ/PF, etc).
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { fmtNum } from "../../lib/format.ts";
import { SERIES_COLORS, tooltipStyle } from "./theme.ts";

interface Slice { name: string; value: number; color?: string }

interface Props {
  data: Slice[];
  height?: number;
  innerRadius?: number;
  /** Função de formatação dos valores no tooltip (default: fmtNum) */
  formatValue?: (v: number) => string;
  /** Texto central (ex: total) */
  centerLabel?: { value: string; sub?: string };
}

export function DonutChart({
  data,
  height = 260,
  innerRadius = 60,
  formatValue = fmtNum,
  centerLabel,
}: Props) {
  if (!data.length) return <div className="center-loading">sem dados</div>;
  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <div style={{ position: "relative" }}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            innerRadius={innerRadius}
            outerRadius={Math.round(innerRadius * 1.5)}
            paddingAngle={2}
            dataKey="value"
            stroke="#fff"
            strokeWidth={2}
          >
            {data.map((d, i) => (
              <Cell key={i} fill={d.color ?? SERIES_COLORS[i % SERIES_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            {...tooltipStyle}
            formatter={(v) => [`${formatValue(v as number)} (${((v as number) / total * 100).toFixed(1)}%)`, ""]}
          />
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            wrapperStyle={{ fontSize: 12 }}
          />
        </PieChart>
      </ResponsiveContainer>
      {centerLabel && (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: height - 40, // legenda em baixo
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}>
          <div style={{ fontFamily: "var(--f-display)", fontSize: "1.7rem", fontWeight: 700, color: "var(--text)" }}>
            {centerLabel.value}
          </div>
          {centerLabel.sub && (
            <div style={{ fontSize: ".72rem", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".1em", marginTop: 2 }}>
              {centerLabel.sub}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
